// extracted by mini-css-extract-plugin
export var btn = "K_mB q_rj q_qW d_bz d_bP d_bD d_dw";
export var full = "K_vw d_w d_H";
export var hoverStyle = "K_mF";
export var zoom = "K_mG";